import { LegacyIIQApi } from '../legacy-iiq-api';

export const getAllPreviousLgmSalesEffectiveDates =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  () =>
    api.get('/fieldOptions/lgmSalesEffectiveDate');
